import { Navigate } from "react-router"
import { useAuth } from "./use-auth"
import EnkLoader from "../components/common/loader"

// Schermt een route af op basis van module-toegang (canUseModules). Wordt gebruikt naast
// EnkProtectedRoute: die controleert authenticatie, deze controleert of de gebruiker de
// betreffende module mag gebruiken. Zonder toegang volgt een redirect naar het dashboard,
// zodat een module die niet in het menu staat ook niet via een directe URL bereikbaar is.
export default function EnkModuleRoute({ moduleId, children }: { moduleId: number; children: JSX.Element }) {
  const auth = useAuth()

  if (auth.loading) {
    return <EnkLoader />
  }

  if (!auth.user?.canUseModules.includes(moduleId)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}
